import React, { useState } from 'react';
import { useRouter } from 'next/router';
import dynamic from 'next/dynamic';
import { useDispatch } from 'react-redux';
import { useEventProvider } from '@/helpers/event-context';
import { openDemoPopup } from '@/redux/popup-manager/actions';
import BookADemoCard from '../BookADemoCard';
import styles from './BookDemoSection.module.scss';
import { useBookDemoEvent } from '@/src/core/hooks/useBookDemoEvent';
import { CeoCalendlyLinks } from '@/src/shared/constants/calendly';

const BookDemoPopup = dynamic(
  () => import('@/src/containers/ContactUs/components/BookDemoPopup'),
  { ssr: false }
);

const items = [
  {
    src: '/images/contact-us/new/one.png',
    id: 1,
    type: 'book-ceo-demo',
    title: (
      <>
        CEO <br /> Demo Session
      </>
    ),
    description: (
      <>
        If you are still hesitant to use our service and want to learn more
        about Roomvu, meet <strong>Sam Mehrbad Ph.D.</strong> for a 15-min demo
        session.
      </>
    ),
    ctaLabel: 'Book a 15-min Demo',
  },
  {
    src: '/images/contact-us/new/two.png',
    id: 2,
    type: 'book-demo',
    title: (
      <>
        Free <br /> Onboarding Session
      </>
    ),
    description: (
      <>
        If you intend to buy a subscription or upgrade your account and want to
        know more about <strong>Roomvu Plans</strong>, contact our sales team.
      </>
    ),
    ctaLabel: 'Book a 15-min Demo',
  },
  {
    src: '/images/contact-us/new/three.png',
    id: 3,
    type: 'brokerage',
    title: (
      <>
        Use Roomvu at <br /> your Brokerage
      </>
    ),
    description: (
      <>
        Become a Roomvu <strong>Brokerage Partner</strong> And provide your
        agents with top quality content
      </>
    ),
    ctaLabel: 'Book A Brokerage demo',
  },
];

export function BookDemoSection() {
  const { getPageName } = useEventProvider();
  const [showModal, setShowModal] = useState(false);
  const router = useRouter();
  const dispatch = useDispatch();
  const { sendBookDemoEvent } = useBookDemoEvent();

  const handleBookACeoDemo = () => {
    sendBookDemoEvent('book-demo-section');
    dispatch(
      openDemoPopup({
        link: CeoCalendlyLinks.free,
      })
    );
  };

  const handleBookADemo = () => {
    sendBookDemoEvent('book-demo-section');
    setShowModal(true);
  };

  const handleClick = (actionType: string) => {
    if (actionType === 'book-ceo-demo') handleBookACeoDemo();
    else if (actionType === 'book-demo') handleBookADemo();
  };

  return (
    <>
      <section className={styles.container}>
        <div className={styles.top}>
          <h2 className={styles.title}>Book a Demo Whenever You want </h2>
          <p className={styles.subTitle}>
            For any issues with Roomvu, you can check our Calendly at any time
            and Book an Online Demo Session on <strong>Zoom</strong>.
          </p>
        </div>
        <div className={styles.demoContainers}>
          {items.map((item) => (
            <BookADemoCard
              key={item.id}
              src={item.src}
              title={item.title}
              description={item.description}
              ctaLabel={item.ctaLabel}
              onCtaClick={() => handleClick(item.type)}
            />
          ))}
        </div>
      </section>
      {showModal && (
        <BookDemoPopup
          open={showModal}
          onClose={() => setShowModal(false)}
          source={getPageName()}
        />
      )}
    </>
  );
}
